module.exports = __webpack_public_path__ + "static/media/categoryIncludeCode.67adb23a.xlsx";